const defer = window.requestIdleCallback || window.requestAnimationFrame;
const isExpired = (entry, expire = 0) => !!expire && entry.timestamp + expire < Date.now();
const isSameVersion = (entry, version) => entry.version === version;
const setItem = (key, data, { version, storage }) => {
    const entry = {
        timestamp: Date.now(),
        data,
        version,
    };
    defer(() => storage.setItem(key, JSON.stringify(entry)));
    return entry;
};
const getItem = (key, options, cached) => {
    const { storage, version, expire } = options;
    const entry = !cached ? JSON.parse(storage.getItem(key)) : cached;
    if (!entry || isExpired(entry, expire) || !isSameVersion(entry, version)) {
        removeItem(key, options);
        return null;
    }
    return entry;
};
const removeItem = (key, { storage }) => {
    defer(() => storage.removeItem(key));
};
export function getBucket(name, options) {
    options = Object.assign({ storage: localStorage }, options);
    let cached = null;
    return [
        () => {
            cached = getItem(name, options, cached);
            return cached ? cached.data : options.defaultValue;
        },
        (value) => {
            cached = setItem(name, value, options);
        },
        () => {
            removeItem(name, options);
            cached = null;
        },
    ];
}
